import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { CarouselModule } from "@shared/components/carousel/carousel.module";
import { SearchRiskTagsModule } from "@shared/components/search-risk-tags/search-risk-tags.module";
import { MinorUnitCurrencyPipe } from "@shared/pipes/minor-unit-currency.pipe";
import { PluralTranslatePipe } from "@shared/pipes/plural-translate.pipe";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { CartIconPipe, CartTooltipPipe } from "../domain/pipes/cart.pipe";
import { RiskDetailsPageComponent } from "./risk-details-page/risk-details-page.component";
import { RisksPageComponent } from "./risks-page/risks-page.component";

const materialModules = [MatProgressSpinnerModule, MatPaginatorModule, MatIconModule, MatTooltipModule];

@NgModule({
  declarations: [RisksPageComponent, RiskDetailsPageComponent],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    RouterModule,
    CartIconPipe,
    CartTooltipPipe,
    CarouselModule,
    SearchRiskTagsModule,
    MinorUnitCurrencyPipe,
    PluralTranslatePipe,
    ...materialModules,
  ],
})
export class RisksModule {}
